var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0Calories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1045 35.9375V42.1875M15.1045 42.1875V48.4375M15.1045 42.1875L21.3545 35.9375M15.1045 42.1875L21.3545 48.4375M29.6878 40.1041H28.6462C26.3449 40.1041 24.4795 41.9695 24.4795 44.2708C24.4795 46.572 26.3449 48.4375 28.6462 48.4375H29.6878M33.8545 48.4375L34.6357 46.3541M34.6357 46.3541L36.9795 40.1041L39.3232 46.3541M34.6357 46.3541H39.3232M39.3232 46.3541L40.1045 48.4375M44.2705 40.1041V48.4375H48.4372M8.20529 43.75C3.10015 39.514 1.5625 32.5729 1.5625 28.3917C1.5625 14.9771 13.6949 1.5625 24.7242 1.5625C15.9007 9.38771 19.2096 19.4487 22.5183 19.4487C26.1896 19.4487 28.0331 15.3498 29.136 12.7414C32.4448 13.8592 39.0625 19.4487 39.0625 28.3917C39.0625 29.5256 38.9206 31.3065 38.421 33.3333",
    stroke: "url(#paint0_linear_147_816)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_816",
    x1: 20.3125,
    y1: 1.5625,
    x2: 20.3125,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0Calories);
export default __webpack_public_path__ + "static/media/0 Calories.ef187b73d5f5953f1300be681ab7dee4.svg";
export { ForwardRef as ReactComponent };